import React from 'react';

import { LandingFaq, FaqListContainer } from '../../styles/LandingStyles';
import InnerContainer from './InnerContainer';
import Typography from '../common/typography/Typography';

import useLanguagePack from '../../hooks/useLanguagePack';
import { useNavigate } from 'react-router-dom';

const Section7 = () => {
  const navigate = useNavigate();
  const languageKeyStrings = {
    title: useLanguagePack('landing_faq_title_1'),
    q1: useLanguagePack('renew_landing_31'),
    a1: useLanguagePack('renew_landing_42'),
    q2: useLanguagePack('renew_landing_32'),
    a2: useLanguagePack('renew_landing_43'),
    a2_1: useLanguagePack('renew_landing_45'),
    q3: useLanguagePack('renew_landing_33'),
    a3: useLanguagePack('renew_landing_44'),
    // q4: useLanguagePack('landing_faq_contents4_title_1'),
    // a4: useLanguagePack('landing_faq_contents4_text_1'),
  };
  return (
    <LandingFaq>
      <InnerContainer>
        <Typography variant={'T1'}>{languageKeyStrings.title}</Typography>
        <FaqListContainer>
          <div>
            <Typography variant={'T3'}>{languageKeyStrings.q1}</Typography>
            <Typography variant={'C4'} color={'gray2'}>
              {languageKeyStrings.a1}
            </Typography>
          </div>
          <div>
            <Typography variant={'T3'}>{languageKeyStrings.q2}</Typography>
            <Typography variant={'C4'} color={'gray2'}>
              {languageKeyStrings.a2}{' '}
              <b
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={e => {
                  navigate('/faq', {
                    state: {
                      parentUid: 7,
                    },
                  });
                }}
              >
                {languageKeyStrings.a2_1}
              </b>
            </Typography>
          </div>
          <div>
            <Typography variant={'T3'}>{languageKeyStrings.q3}</Typography>
            <Typography variant={'C4'} color={'gray2'}>
              {languageKeyStrings.a3}
            </Typography>
          </div>
        </FaqListContainer>
      </InnerContainer>
    </LandingFaq>
  );
};

export default Section7;
